// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

let backendURL = window.location.origin + '/soldraftbackend/index.php';
if (window.location.origin.includes('localhost')) {
    // backendURL = 'https://sol-50.eu/soldraftbackenddev/index.php';
    // backendURL = 'https://soldraft.com/soldraftbackend/index.php';
    // backendURL = 'https://usertest.soldraft.com/soldraftbackend/index.php';
    backendURL = 'http://localhost/soldraftbackend/index.php';
    // backendURL = 'http://soldraft.local/soldraftbackend/index.php';
} else if (window.location.pathname.includes('soldraft.local')) {
    backendURL = window.location.origin + '/soldraftbackend/index.php';
} else if (window.location.pathname.includes('soldrafttest')) {
    backendURL = window.location.origin + '/soldraftbackend/index.php';
} else if (window.location.pathname.includes('soldraftdev')) {
    backendURL = window.location.origin + '/soldraftbackenddev/index.php';
}
export const environment = {
    production: false,
    apiUrl: backendURL,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
